import React from 'react';

import styles from './index.module.css';

const ConvertedAmount = ({ value }) => (
  <div className={styles.root}>
    <span>{value.get('value')}</span> <span>{value.get('currency')}</span>
  </div>
);

export default ConvertedAmount;
